// The artificial phone frame with the Yappyli chat list, light or dark
const img = (id) => `https://images.unsplash.com/photo-${id}?w=100`;

const ME = img('1534528741775-53994a69daeb');

const STORIES = [
  { name: 'Your story', avatar: img('1539571696357-5a69c17a67c6') },
  { name: 'John', avatar: img('1507003211169-0a1dd7228f2d') },
  { name: 'Leo', avatar: img('1517841905240-472988babdf9') },
];

const CHATS = [
  { name: 'Leo Smith', last: '📷 Photo', unread: 1, avatar: img('1517841905240-472988babdf9') },
  { name: 'John D', last: 'I will call you later', unread: 1, avatar: img('1507003211169-0a1dd7228f2d') },
  { name: 'Thabo Mokoena', last: 'Thanks man', unread: 0, avatar: img('1500648767791-00dcc994a43e') },
];

export default function PhoneMockup({ theme = 'light', id }) {
  return (
    <div className="phone-frame">
      <div className={`phone-screen theme-${theme}`} id={id}>
        <div className="app-header">
          <div>
            <span style={{ fontSize: '0.7rem', color: '#64748B' }}>Hello,</span>
            <h3>Sam</h3>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <div
              style={{
                width: 28, height: 28, background: '#F1F5F9', borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '0.8rem', color: '#64748B',
              }}
            >
              <i className="fa-regular fa-moon"></i>
            </div>
            <div className="avatar" style={{ width: 28, height: 28, backgroundImage: `url('${ME}')` }}></div>
          </div>
        </div>

        <div className="stories-bar">
          {STORIES.map((s) => (
            <div className="story-item" key={s.name}>
              <div className="avatar-ring">
                <div className="avatar" style={{ backgroundImage: `url('${s.avatar}')` }}></div>
              </div>
              <span>{s.name}</span>
            </div>
          ))}
        </div>

        <div className="search-box">
          <i className="fa-solid fa-magnifying-glass"></i> Search conversations...
        </div>

        <div className="chat-list">
          {CHATS.map((c) => (
            <div className="chat-item" key={c.name}>
              <div className="avatar" style={{ width: 40, height: 40, backgroundImage: `url('${c.avatar}')` }}></div>
              <div className="chat-info">
                <h4>{c.name}</h4>
                <p>{c.last}</p>
              </div>
              {c.unread > 0 && <span className="badge">{c.unread}</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
